import { BRAND } from "@/brand";
import PublicHeader from "@/components/public/PublicHeader";
import PublicFooter from "@/components/public/PublicFooter";
import WhatsAppButton from "@/components/public/WhatsAppButton";
import { Card } from "@/components/ui/card";
import { COACHES } from "@/data/coaches";
import { useLang } from "@/contexts/LanguageContext";
import { getDict, coachBiosEn } from "@/lib/i18n";
import { ArrowLeft, ArrowRight, Instagram } from "lucide-react";
import { Link } from "wouter";

const IMG_TEAM_GROUP = "/img/gml-team-group_022e6252.jpg";

export default function Equipo() {
  const { lang } = useLang();
  const t = getDict(lang);

  return (
    <div className="min-h-screen bg-[var(--cream)]">
      <PublicHeader />

      <section className="py-16 md:py-24" style={{ scrollMarginTop: 80 }}>
        <div className="container">
          <Link
            href="/"
            className="inline-flex items-center gap-2 text-sm font-medium text-[var(--forest-deep)]/60 hover:text-[var(--forest)] transition-colors mb-10"
          >
            <ArrowLeft size={16} />
            {t.team.backHome}
          </Link>

          <div className="max-w-3xl mb-12">
            <div className="text-xs font-semibold tracking-[0.2em] uppercase text-[var(--forest)]/70 mb-4">
              {t.team.eyebrow}
            </div>
            <h1
              className="font-display font-light text-[var(--forest-deep)] leading-[1.05] tracking-[-0.02em]"
              style={{ fontSize: "clamp(2.25rem, 5.5vw, 4rem)" }}
            >
              {t.team.titleA}
              <span className="italic text-[var(--forest)]">{t.team.titleEm}</span>.
            </h1>
            <p className="mt-6 text-lg text-[var(--forest-deep)]/70 leading-relaxed">
              {t.team.pageIntro}
            </p>
          </div>

          <div className="mb-16 overflow-hidden rounded-2xl border border-[var(--forest-deep)]/10">
            <img
              src={IMG_TEAM_GROUP}
              alt={t.team.groupAlt}
              className="w-full h-auto object-cover"
              loading="lazy"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {COACHES.map((c) => {
              const enOverride = lang === "en" ? coachBiosEn[c.name] : undefined;
              const displayTitle = enOverride?.title ?? c.title;
              const displayBio = enOverride?.bio ?? c.bio;
              return (
                <Card
                  key={c.id}
                  className="p-0 overflow-hidden border border-[var(--forest-deep)]/10 bg-white"
                >
                  <div className="aspect-[4/5] bg-[var(--forest)]/5 overflow-hidden">
                    {c.photoKey ? (
                      <img
                        src={c.photoKey}
                        alt={c.name}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    ) : (
                      <div className="flex items-center justify-center h-full">
                        <img src={BRAND.logoGreenStacked} alt="" className="w-24 opacity-30" />
                      </div>
                    )}
                  </div>
                  <div className="p-6">
                    <h2 className="font-display text-xl font-medium text-[var(--forest-deep)]">{c.name}</h2>
                    <div className="text-xs font-semibold tracking-wide uppercase text-[var(--forest)]/70 mt-1">
                      {displayTitle}
                    </div>
                    {displayBio && (
                      <p className="mt-4 text-sm text-[var(--forest-deep)]/70 leading-relaxed">{displayBio}</p>
                    )}
                    {c.instagramUrl && (
                      <div className="mt-5 pt-5 border-t border-[var(--forest-deep)]/10 flex items-center gap-3">
                        <a
                          href={c.instagramUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={`Instagram · ${c.name}`}
                          className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[var(--forest)]/10 text-[var(--forest-deep)] hover:bg-[var(--forest)] hover:text-[var(--cream)] transition-colors"
                        >
                          <Instagram size={18} />
                        </a>
                        <span className="text-xs text-[var(--forest-deep)]/60">{t.team.followInstagram}</span>
                      </div>
                    )}
                  </div>
                </Card>
              );
            })}
          </div>

          <div className="mt-16 flex flex-col sm:flex-row gap-3">
            <Link
              href="/#contacto"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[var(--forest)] text-[var(--cream)] rounded-full font-semibold tracking-wide hover:bg-[var(--forest-deep)] transition-colors"
            >
              {t.hero.ctaPrimary}
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>

      <PublicFooter />
      <WhatsAppButton />
    </div>
  );
}
